/**
 * Pré-remplit le formulaire de rétractation (Power Form Builder) depuis les query params de l'extension compte client.
 * Globo rend le formulaire en asynchrone : on observe le DOM jusqu'au remplissage (timeout 20 s).
 * L'ordre des règles compte (« prénom » avant « nom », dates avant n° de commande).
 */

const params = new URLSearchParams(window.location.search);

const RULES = [
  { param: 'prenom', match: (label) => /pr[ée]nom|first ?name/.test(label) },
  {
    param: 'nom',
    match: (label) => !/pr[ée]nom/.test(label) && /nom|last ?name/.test(label),
  },
  {
    param: 'email',
    match: (label, input) => input.type === 'email' || /e-?mail|courriel/.test(label),
  },
  { param: 'adresse', match: (label) => /adresse|address/.test(label) },
  { param: 'date_commande', match: (label) => /date.*(commande|achat)|order date/.test(label) },
  {
    param: 'date_reception',
    match: (label) => /r[ée]ception|livraison|delivery/.test(label),
  },
  {
    param: 'commande',
    match: (label) => !/date/.test(label) && /commande|order/.test(label),
  },
  { param: 'produits', match: (label) => /produit|quantit|article|product/.test(label) },
].filter((rule) => params.get(rule.param));

if (RULES.length) {
  const TIMEOUT_MS = 30000;
  const SELECTOR =
    '.globo-formbuilder input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), .globo-formbuilder textarea';
  // Champs où l'utilisateur est intervenu : on n'y touche plus.
  const owned = new WeakSet();
  document.addEventListener('focusin', (event) => {
    if (event.target.closest?.('.globo-formbuilder')) owned.add(event.target);
  });

  const labelTextFor = (input) => {
    let text = ` ${input.placeholder || ''} ${input.name || ''} ${input.getAttribute('aria-label') || ''}`;
    if (input.id) {
      const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (label) text += ` ${label.textContent}`;
    }
    // Remonte jusqu'à 5 ancêtres pour trouver le <label>, sans sortir du groupe (plusieurs inputs).
    let node = input.parentElement;
    for (let depth = 0; node && depth < 5; depth += 1) {
      if (node.querySelectorAll('input, textarea, select').length > 1) break;
      const label = node.querySelector('label');
      if (label) {
        text += ` ${label.textContent}`;
        break;
      }
      node = node.parentElement;
    }
    return text.toLowerCase();
  };

  const setValue = (input, value) => {
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('blur', { bubbles: true }));
  };

  // Rejouable : Globo peut re-rendre son formulaire après coup et vider les champs.
  // L'attribution règle → champ est refaite à chaque passage, et seul un champ vide est rempli.
  const tryFill = () => {
    const free = new Set(RULES);
    for (const input of document.querySelectorAll(SELECTOR)) {
      if (!free.size) break;
      const label = labelTextFor(input);
      for (const rule of free) {
        if (rule.match(label, input)) {
          free.delete(rule);
          if (!owned.has(input) && !input.value) setValue(input, params.get(rule.param));
          break;
        }
      }
    }
  };

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      tryFill();
    });
  });

  const start = () => {
    tryFill();
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), TIMEOUT_MS);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}
